export enum FilterType {
	INPUT = 'input',
	DATE = 'date',
	SELECT = 'select',
	AUTOCOMPLETE = 'autocomplete',
	AUTOCOMPLETE_EAGER = 'autocomplete-eager',
	TEXTAREA = 'textarea',
	FILE = 'file'
}